module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("对话框 - <uk-modal>")]), _vm._v(" "), _c('h2', [_vm._v("基本用法")]), _vm._v(" "), _c('h3', [_vm._v("示例")]), _vm._v(" "), _c('uk-button', {
    on: {
      "click": _vm.open
    }
  }, [_vm._v("打开对话框")]), _vm._v(" "), _c('uk-modal', {
    ref: "dialog",
    attrs: {
      "title": "对话框标题"
    }
  }, [_c('p', [_vm._v("您好！这是一段简单的文字内容")])]), _vm._v(" "), _c('h3', [_vm._v("代码")]), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.basic))]), _vm._v(" "), _c('h2', [_vm._v("Lightbox 支持")]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('code-block', [_vm._v(_vm._s(_vm.usages.lightbox))]), _vm._v(" "), _c('uk-button', {
    on: {
      "click": function($event) {
        _vm.$refs.lightboxDlg.open()
      }
    }
  }, [_vm._v("Lightbox")]), _vm._v(" "), _c('uk-modal', {
    ref: "lightboxDlg",
    attrs: {
      "closable": true,
      "lightbox": true
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/placeholder_600x400.svg"),
      "width": "600",
      "height": "400",
      "alt": ""
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("全屏页")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p'), _vm._v(" "), _c('uk-button', {
    on: {
      "click": function($event) {
        _vm.$refs.blankDlg.open()
      }
    }
  }, [_vm._v("Blank")]), _vm._v(" "), _c('uk-modal', {
    ref: "blankDlg",
    attrs: {
      "closable": true,
      "blank": true
    }
  }, [_c('div', {
    staticClass: "uk-grid uk-flex-middle",
    attrs: {
      "data-uk-grid-margin": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-medium-1-2 uk-height-viewport uk-cover-background uk-row-first",
    staticStyle: {
      "background-image": "url('../assets/placeholder_120x255.svg')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-width-medium-1-2 uk-row-first"
  }, [_c('h1', [_vm._v("Headline")]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-medium-1-3"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et\n            dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex\n            ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu\n            fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt\n            mollit anim id est laborum.")])])])])]), _vm._v(" "), _c('h3', [_vm._v("属性")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("只要设置 "), _c('code', [_vm._v(":lightbox=\"true\"")]), _vm._v(" 就只会显示一个lightbox样式的图片对话框。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "uk-table uk-table-striped uk-table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("属性")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('code', [_vm._v("keyboard")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("允许使用键盘的ESC键关键对话框")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("lightbox")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("开启lightbox支持")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("blank")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("开启全屏支持")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("bgclose")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("允许点击背景自动关闭对话框。")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("minScrollHeight")])]), _vm._v(" "), _c('td', [_vm._v("integer")]), _vm._v(" "), _c('td', [_vm._v("150")]), _vm._v(" "), _c('td', [_vm._v("设置遮盖层开始滑动的值。")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("center")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._v("设计垂直居中")])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("modal")])]), _vm._v(" "), _c('td', [_vm._v("boolean")]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_vm._v("只能通过点击关闭按钮关闭的模态对话框")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cc10a118!./~/vue-loader/lib/selector.js?type=template&index=0!./src/docs/UkModal.doc.vue
// module id = 303
// module chunks = 2